import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const ImplementerVisionInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Visión de la implementadora">
      {getFieldDecorator("implementerVision", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa la visión de la implementadora."
          }
        ],
        initialValue: implementerProfile?.implementerVision
      })(
        <Input
          disabled={isBusy}
          id="implementerVision"
          name="implementerVision"
          placeholder="Visión de la implementadora"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
